import styled from "styled-components";
import { StyledRowProps } from "./TableRow.types";

export const StyledTableRow = styled.tr<StyledRowProps>`
	${({ variant, theme }) => {
		const getTrimColor = () => {
			switch (variant) {
				case "error":
					return "semantic_error_600";
				case "alert":
					return "semantic_warning_400";
				case "success":
					return "semantic_success_500";
				case "info":
					return "semantic_info_600";
			}
		};

		return {
			...(variant !== "default" && {
				"td:first-of-type:before": {
					content: "''",
					height: "100%",
					width: theme.space.xs,
					backgroundColor: theme.palette.hexForMandatory(getTrimColor()),
					position: "absolute",
					top: 0,
					left: 0,
				},
			}),
		};
	}}
`;
